import { Component, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  imports: [MatTooltip],
  selector: 'avs-status-count',
  templateUrl: './status-count.component.html',
})
export class StatusCountComponent {
  active = input<number>(0);
  paused = input<number>(0);
  showTooltip = input<boolean>(true);
}
